import React from 'react'
import { Avatar } from '@hub/avatar'
import { UserMediumIcon } from '@hub/icon'
import { Box } from '@hub/box'
import { Text } from '@hub/text'
import { Stack } from '@hub/stack'
import { AccountPaneProps } from './types'

export const AccountPaneLarge: React.FC<AccountPaneProps> = ({
  name,
  avatarSrc,
  isLoggedIn,
  displayAccountNav,
  sx,
}) => (
  <Box
    sx={sx}
    as="button"
    aria-label={
      isLoggedIn ? 'View your account details' : 'Log into Westfield Plus'
    }
    onClick={() => displayAccountNav(true)}
  >
    <Stack
      sx={{
        width: 'max-content',
        '&:hover': {
          color: 'quartz',
        },
        '&:active': {
          color: 'manatee',
        },
        '&:hover .chakra-avatar': {
          backgroundColor: 'quartz',
        },
        '&:active .chakra-avatar': {
          backgroundColor: 'manatee',
        },
      }}
      align="center"
      shouldWrapChildren={false}
      direction="row"
      gap={'spacing-sm'}
    >
      {isLoggedIn ? (
        <>
          <Avatar name={name} src={avatarSrc} />

          <Stack>
            <Text fontSize="font-sm" tone="strong" sx={{ textAlign: 'left' }}>
              Account
            </Text>

            <Text
              fontSize="font-xs"
              color="licorice"
              sx={{ textAlign: 'left' }}
            >
              Orders, settings…
            </Text>
          </Stack>
        </>
      ) : (
        <>
          <UserMediumIcon boxSize="size-icon-md" />
          <Stack>
            <Text fontSize="font-sm" tone="strong" sx={{ textAlign: 'left' }}>
              Westfield Plus
            </Text>
            <Text
              fontSize="font-xs"
              color="licorice"
              sx={{ textAlign: 'left' }}
            >
              Get more everyday
            </Text>
          </Stack>
        </>
      )}
    </Stack>
  </Box>
)
